<script setup lang="ts">
/* A reply into one thread, straight from its Back with you card. The panel
   mounts at most one, only while replying, and it is the same room and
   composer the thread page uses, so @mentions and the "not connected" guard
   match. No offline copy: the page may hold this policy's room too, and this
   one only sends a comment. */
const { policyId, threadId, itemId } = defineProps<{
  policyId: string
  threadId: string
  itemId: string
}>()

const emit = defineEmits<{ sent: [] }>()

const room = usePolicyRoom(policyId, { persistence: false })
const toast = useToast()
const composer = useTemplateRef('composer')

watch(
  room.canDiscuss,
  (ready) => {
    if (ready) void composer.value?.focus()
  },
  { flush: 'post', once: true },
)

const failed = computed(
  () => room.collab.status.value === 'error' || room.notFound.value,
)

const onSent = () => {
  toast.add({ title: 'Reply sent', color: 'success' })
  emit('sent')
}
</script>

<template>
  <div class="space-y-1">
    <PolicyStudioComposer
      ref="composer"
      :item-id="itemId"
      :parent-id="threadId"
      :room="room"
      placeholder="Reply…"
      submit-label="Reply"
      @sent="onSent"
    />
    <p v-if="!room.canDiscuss.value" class="text-dimmed text-xs">
      {{ failed ? 'Could not connect to this policy.' : 'Connecting…' }}
    </p>
  </div>
</template>
